module.exports = __webpack_public_path__ + "img/questions.c50265a4.png";